<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { faSparkles } from '@fortawesome/duotone-regular-svg-icons'
import AuPopover from '~/components/ui/AuPopover.vue'

const { t } = useI18n()
</script>

<template>
  <AuPopover align="start" position-strategy="absolute">
    <template #trigger>
      <button class="mb-4 flex w-fit items-center gap-1 text-(--theme-50) underline underline-offset-2 transition hover:text-(--theme-40) focus-visible:ring">
        <font-awesome-icon :icon="faSparkles" />
        {{ t('chatbot.info.title') }}
      </button>
    </template>
    <template #content>
      <article class="max-w-xl space-y-3 p-4">
        <h3 class="text-xl font-bold" v-text="t('chatbot.info.heading')" />
        <p v-text="t('chatbot.info.paragraph1')" />
        <p v-text="t('chatbot.info.paragraph2')" />
        <p v-text="t('chatbot.info.paragraph3')" />
      </article>
    </template>
  </AuPopover>
</template>
